import { MutationTree } from 'vuex';

// Store types
import { RootState, Mutation } from '@/store/store.types';

// Every section's mutations
import { Mutations as CompanyMutations } from '@/store/sections/company/company.mutations';
import { Mutations as FooterMutations } from '@/store/sections/footer/footer.mutations';
import { Mutations as ProductsMutations } from '@/store/sections/products/products.mutations';
import { Mutations as RequestMutations } from '@/store/sections/request/request.mutations';
import { Mutations as SpacesMutations } from '@/store/sections/spaces/spaces.mutations';
import { Mutations as StepsMutations } from '@/store/sections/steps/steps.mutations';
import { Mutations as SystemsMutations } from '@/store/sections/systems/systems.mutations';

/**
 *  Holding all the application store's mutations.
 */
export const mutations: MutationTree<RootState> = {

    /**
     *  Used to update the loading state of the application.
     */
    [Mutation.LOADING](state: RootState, loading: boolean): void {

        state.loading = loading;

    },

    /**
     *  Used to update the internal state of the application.
     */
    [Mutation.INTERNAL](state: RootState, internal: boolean): void {

        state.internal = internal;

    },

    /**
     *  Every section's mutation.
     */
    ...CompanyMutations,
    ...FooterMutations,
    ...ProductsMutations,
    ...RequestMutations,
    ...SpacesMutations,
    ...StepsMutations,
    ...SystemsMutations,

};
